<template>
  <router-view v-slot="{ Component }">
    <v-fade-transition mode="out-in">
      <component :is="Component" />
    </v-fade-transition>
  </router-view>
</template>

<style>
@font-face {
  font-family: Noto;
  src: url(./assets/fonts/Noto-IKEA/Latin/NotoIKEALatin-Regular.ttf)
    format("truetype");
  font-weight: normal;
  font-style: normal;
}

@font-face {
  font-family: Noto;
  src: url(./assets/fonts/Noto-IKEA/Latin/NotoIKEALatin-Italic.ttf)
    format("truetype");
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: Noto;
  src: url(./assets/fonts/Noto-IKEA/Latin/NotoIKEALatin-Bold.ttf)
    format("truetype");
  font-weight: bold;
  font-style: normal;
}

@font-face {
  font-family: Noto;
  src: url(./assets/fonts/Noto-IKEA/Latin/NotoIKEALatin-BoldItalic.ttf)
    format("truetype");
  font-weight: bold;
  font-style: italic;
}
</style>

<script lang="ts">
import { defineComponent, onMounted } from "vue";

export default defineComponent({
  name: "App",
  setup() {
    // Lifecycle hook
    onMounted(() => {
      const appTitle = import.meta.env.VITE_APP_TITLE || "App";
      document.title = appTitle; // Set the document title dynamically
    });
  }
});
</script>
